module.exports = __webpack_public_path__ + "img/Postmodernisme_Jurgen-Habermas.97001d48.jpg";